<template>
    <div class="question">
        <h1>{{ question.question }}</h1>
        <div class="answers">
            <Answer v-for="answer in question.answers" :key="answer.id" :answer="answer" @handleAnswer="handleAnswer" />
        </div>
        <div class="buttons">
            <button class="app-btn" @click="$emit('back')">Terug</button>
        </div>
    </div>
</template>

<script>
import Answer from '@/components/Answer.vue'
export default {
    name: 'Question',
    components: {
        Answer
    },
    props: {
        question: Object
    },
    methods: {
        handleAnswer (code) {
            this.$emit('handleAnswer', this.question.code, code)
        }
    }
}
</script>

<style lang="scss" scoped>
    @use '../assets/scss/main.scss' as *;

    .answers {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        @include bp-lg {
            flex-direction: row;
            margin-top: 0;
        }
    }
</style>
